export const CONTENT_REQUEST = 'CONTENT_REQUEST';
export const CONTENT_SUCCESS = 'CONTENT_SUCCESS';
export const CONTENT_FAILURE = 'CONTENT_FAILURE';
export const CONTENT_CLEAR = 'CONTENT_CLEAR';

export const LATEST_CONTENT_REQUEST = 'LATEST_CONTENT_REQUEST';
export const LATEST_CONTENT_SUCCESS = 'LATEST_CONTENT_SUCCESS';
export const LATEST_CONTENT_FAILURE = 'LATEST_CONTENT_FAILURE';
export const LATEST_CONTENT_CLEAR = 'LATEST_CONTENT_CLEAR';
